import React, { Component } from 'react'
import styled from 'styled-components';
import ShareIcon from './ShareIcon'
import Burger from './Burger'
import { urls, shareUrl } from '../consts'
import fbIcon from '../static/images/icons/fb.png'
import twtIcon from '../static/images/icons/twt.png'
import wsIcon from '../static/images/icons/ws.png'
import accessSrc from '../static/images/icons/access.png'
import ynetIcon from '../static/images/icons/ynet_purple.png'
import shareIcon from '../static/images/icons/share.png'
import logoSrc from '../static/images/general/logo.png'
import arrowLeft from '../static/images/icons/arrow_left.png'
import NavList from './NavList'
import navItems from '../data/nav-items.json'
import { media, colors } from '../styles/vars'
import { push } from '../analytics'
import { Link } from 'react-router-dom'

const StyledHeader = styled.header`
position:fixed;
top:0;
left:0;
right:0;
backface-visibility:hidden;
transform:translate3d(0, 0, 0);
will-change:transform;
z-index:150;
height:60px;
background-color:${props => props.active ? 'rgba(0, 0, 0, .8)' : 'transparent'};
transition:background-color .4s;
`;
const HeaderContent = styled.div`
height:100%;
display:flex;
justify-content:space-between;
align-items:center;
padding:0 10px;
`
const FlexContainer = styled.div`
display:flex;
`
const NavListContainer = styled.div`
position:absolute;
top:60px;
left:0;
width:100%;
height:80vh;
overflow:hidden;
transition: max-height .6s;
max-height:${props => props.active ? '100vh' : 0};
${
    media.desktop`
    height:initial;
    max-height:${props => props.active ? '400px' : 0};
    width:200px;
    `
    }
`
const ShareContainer = styled.div`
transition:opacity .4s, visibility .4s;
visibility:${props => props.active ? 'visible' : 'hidden'};
opacity:${props => props.active ? '1' : '0'};
position:absolute;
top:60px;
left:65px;
display:flex;
flex-direction:column;
${
    media.desktop`
    position:static;
    visibility:visible;
    opacity:1;
    display:block;
    `
    }
`
const YnetLogo = styled.a`
width:90px;
display:block;
${
    media.desktop`
    width:initial;
    `
    }
`
const BackLink = styled(Link) `
    display:${props => props.shown ? 'inline-block' : 'none'};
    width:40px;
    height:40px;
    background-color:${colors.black};
    border-radius:50%;
    margin-left:10px;
    background-repeat:no-repeat;
    background-size:15px;
    background-position:center left 12px;
    background-image:url(${arrowLeft});
    label{
        display:none;
    }
    ${
    media.desktop`
        &, &:visited, &:hover{
            color:${colors.white};
            text-decoration:none;
        }
        label{
            display:block;
            cursor:pointer;
        }
        width:auto;
        line-height:42px;
        border-radius:7px;
        font-size:2rem;
        padding:0 10px 0 50px;
        `
    }
    
`
const SiteLogo = styled(Link) `
width:100px;
margin-right:10px;
transition:visibility .4s, opacity .4s;
${
    media.small`
    display:none;
    `
    }
    ${
    media.desktop`
    width:120px;
    margin-right:15px;
        `
    }
`
const DynamicSiteLogo = styled(SiteLogo) `
visibility:${props => props.shown ? 'visible' : 'hidden'};
opacity:${props => props.shown ? '1' : '0'};
`
const onAccessClick = () => {
    window.document.getElementById('INDmenu-btn').click();
}
const onFacebookShare = () => {
    push('Share_Facebook', shareUrl);
}
const onWhatsappShare = () => {
    push('Share_Whatsapp', shareUrl);
}
const onTwitterShare = () => {
    push('Share_Twitter', shareUrl);
}
class Header extends Component {
    constructor(props) {
        super();
        this.toggleScroll = this.toggleScroll.bind(this);
        this.toggleMenu = this.toggleMenu.bind(this);
        this.toggleShare = this.toggleShare.bind(this);
        this.closeMenu = this.closeMenu.bind(this);
        this.state = {
            active: props.alwaysActive
        };
    }
    componentDidMount() {
        if (this.props.alwaysActive) return;

        this.toggleScroll();
        window.addEventListener('scroll', this.toggleScroll);
    }

    componentWillUnmount() {
        if (this.props.alwaysActive) return;

        window.removeEventListener('scroll', this.toggleScroll);
    }
    toggleScroll() {
        const isActive = window.scrollY > 100;
        if (this.state.active === isActive) return;
        this.setState({
            active: isActive
        });
    }
    toggleMenu(flag) {
        this.setState({
            menuActive: typeof flag === 'boolean' ? flag : !this.state.menuActive
        });
    }
    closeMenu() {
        this.toggleMenu(false);
    }
    toggleShare() {
        this.setState({
            showShare: !this.state.showShare
        });
    }
    render() {
        return (
            <StyledHeader active={this.state.active}>
                <NavListContainer active={this.state.menuActive}>
                    <NavList
                        items={navItems}
                        noScroll={this.props.noScroll}
                        onItemClick={this.closeMenu}
                        isMobile={this.props.isMobile}
                    />
                </NavListContainer>
                <HeaderContent>
                    <FlexContainer>
                        <YnetLogo
                            href="https://www.ynet.co.il"
                            target="_blank"
                            rel="noopener noreferrer"
                        >
                            <img src={ynetIcon} alt="" />
                        </YnetLogo>
                        <DynamicSiteLogo to="/" shown={(this.state.active || '').toString()}>
                            <img src={logoSrc} alt="" />
                        </DynamicSiteLogo>
                    </FlexContainer>
                    <FlexContainer>
                        <BackLink
                            to="/"
                            replace
                            shown={(this.props.showBackLink || '').toString()}
                        >
                            <label>לחזרה לעמוד הראשי</label>
                        </BackLink>
                        <ShareIcon
                            imageSrc={accessSrc}
                            onClick={onAccessClick}
                        />
                        <ShareIcon
                            imageSrc={shareIcon}
                            white
                            mobileOnly
                            onClick={this.toggleShare}
                        />
                        <ShareContainer active={this.state.showShare}>
                            <ShareIcon
                                imageSrc={wsIcon}
                                href={urls.whatsapp}
                                customAttrs={{
                                    'data-action': 'share/whatsapp/share'
                                }}
                                self
                                mobileOnly
                                onClick={onWhatsappShare}
                                botMargin
                            />
                            <ShareIcon
                                imageSrc={twtIcon}
                                href={urls.twitter}
                                onClick={onTwitterShare}
                                desktopOnly
                            />
                            <ShareIcon
                                imageSrc={fbIcon}
                                href={urls.facebook}
                                onClick={onFacebookShare}
                                botMargin
                            />
                        </ShareContainer>
                        <Burger
                            onClick={this.toggleMenu}
                            isActive={this.state.menuActive}
                        />
                    </FlexContainer>
                </HeaderContent>
            </StyledHeader>
        )
    }
}

export default Header;


// WEBPACK FOOTER //
// ./src/components/Header.jsx